const getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export default getRandomIntInclusive;


// WEBPACK FOOTER //
// ./src/utils/getRandomIntInclusive.js